import React from 'react'
import { Table, Thead, Tbody, Tr, Th } from '@chakra-ui/react'
import classes from './MyStudentsTable.module.css'
import MyStudentsTableRecord from './MyStudentsTableRecord'
import { useStudentsStore } from '../../store/studentsStore'
import { getSearchStudents } from '../../utils/studentsHelper'

function MyStudentsTable() {
    const students = useStudentsStore(state => state.students)
    const searchFilters = useStudentsStore(state => state.searchFilters)
    const searchStudents = getSearchStudents(searchFilters, students)

    return (
        searchStudents?.length > 0 &&
        <Table className={classes.table}>
            <Thead>
                <Tr>
                    <Th className={classes.fixedHeadCol}>Имя</Th>
                    <Th>ID платформы</Th>
                    <Th>Дата рождения</Th>
                    <Th>Почта</Th>
                    <Th>Тип предпочтительной связи</Th>
                    <Th>Группа</Th>
                    <Th>Класс</Th>
                    <Th textAlign='center'>Поток</Th>
                    <Th>Тариф</Th>
                    <Th textAlign='center'>Предмет</Th>
                    <Th>Сдаваемость</Th>
                    <Th>Просмотренность</Th>
                    <Th>Цели</Th>
                    <Th>Первоначальные баллы</Th>
                    <Th>Статус знакомства/онбординга</Th>
                    <Th>Тэги</Th>
                    <Th>Время покупки</Th>
                    <Th>Комментарий</Th>
                </Tr>
            </Thead>
            <Tbody>
                {searchStudents.map(student => (
                    student && <MyStudentsTableRecord student={student} key={`student-record-${student.site_id}`} />
                ))}
            </Tbody>
        </Table>
    )
}

export default MyStudentsTable
